module.exports = __webpack_public_path__ + "img/ppt.75ec456a.svg";